const PageLoader = () => (
  <div
    className="fixed inset-0 flex items-center justify-center"
    style={{ background: "#E9E4DE" }}
  >
    <div className="relative w-11 h-11">
      {/* Anello di base */}
      <div className="absolute inset-0 rounded-full border-[3px] border-[#B39678]/25" />
      {/* Arco rotante brand */}
      <div className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-[#86694B] animate-spin" />
    </div>
  </div>
);

export default PageLoader;
